import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import EarningsTable from "../../../../Components/Host/Dashboard/EarningsTable";
import PayoutsTable from "../../../../Components/Host/Dashboard/PayoutsTable";
import RefundsTable from "../../../../Components/Host/Dashboard/RefundsTable";
import { fetchCmsMetaData } from "../../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../../Components/Utility/setMetaTags";



function HostPaymentReview() {
const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(0);

  const [meta,setMeta] = useState();

   useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "earning") setActiveTab(0);
    else if (tabParam === "refund") setActiveTab(1);
    else if (tabParam === "payout") setActiveTab(2);
  }, [searchParams]);

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("payment");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <section className="mng_bottomss user_allls profiles all_titless myprofiless user_allls ntx_tabs_links usr_experience al_bootm_spance">

       <SetMetaTags
        title= {meta?.meta_title || "Payment | Weyfarin"}
        description={meta?.meta_description || "Payment | Weyfarin"}
      
      />

      <div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
        <div className="row">
          <div className="col-lg-12">
            <div className="discriptionns spcemnges">
              <h3>Your Payments</h3>
              <p>Track all your reservations, payments, and refunds here.</p>
            </div>

            <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
              <TabList>
                <Tab><h5>Total Earning</h5></Tab>
                <Tab><h5>Total Refund</h5></Tab>
                <Tab><h5>Total Payout</h5></Tab>
              </TabList>

              <TabPanel>
                <EarningsTable />
              </TabPanel>

              <TabPanel>
                <RefundsTable />
              </TabPanel>

              <TabPanel>
                <PayoutsTable />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HostPaymentReview;
